module.exports = __webpack_public_path__ + "static/media/Slider 2 3.a1082039.jpg";